import { data } from '../../svg/ChartLine/data';
import { makeIcon } from '../makeIcon';

export const ChartLine = makeIcon(data, 'chart_line', 'ChartLine');

export default ChartLine;
